/**
 * Tarih yardımcıları — vardiya planlaması için.
 * Hafta başlangıcı = Pazartesi.
 */

export const GUN_ADLARI = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'] as const
export const GUN_ADLARI_UZUN = [
  'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar',
] as const

/**
 * YYYY-MM-DD formatında tarih.
 */
export function tarihStr(d: Date): string {
  const yil = d.getFullYear()
  const ay = String(d.getMonth() + 1).padStart(2, '0')
  const gun = String(d.getDate()).padStart(2, '0')
  return `${yil}-${ay}-${gun}`
}

export function tarihParse(s: string): Date {
  const [y, m, d] = s.split('-').map(Number)
  return new Date(y, m - 1, d)
}

/**
 * Verilen tarihin Pazartesi'sini döndürür.
 */
export function pazartesi(tarih: Date | string): Date {
  const d = typeof tarih === 'string' ? tarihParse(tarih) : new Date(tarih)
  d.setHours(0, 0, 0, 0)
  const gun = d.getDay() // 0=Pazar, 1=Pzt
  const fark = gun === 0 ? -6 : 1 - gun
  d.setDate(d.getDate() + fark)
  return d
}

export function ekleGun(d: Date, n: number): Date {
  const yeni = new Date(d)
  yeni.setDate(yeni.getDate() + n)
  return yeni
}

/**
 * Bir haftanın 7 gününü döndürür (Pazartesi-Pazar).
 */
export function haftaTarihleri(haftaBaslangic: Date): Date[] {
  return Array.from({ length: 7 }, (_, i) => ekleGun(haftaBaslangic, i))
}

/**
 * "5 May - 11 May 2026" gibi etiket.
 */
export function haftaEtiketi(haftaBaslangic: Date): string {
  const son = ekleGun(haftaBaslangic, 6)
  const aylar = [
    'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz',
    'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara',
  ]
  const b = `${haftaBaslangic.getDate()} ${aylar[haftaBaslangic.getMonth()]}`
  const s = `${son.getDate()} ${aylar[son.getMonth()]} ${son.getFullYear()}`
  return `${b} – ${s}`
}

/**
 * Bugünün hafta başlangıcı.
 */
export function buHaftaninPazartesi(): Date {
  return pazartesi(new Date())
}

export function bugunMu(d: Date): boolean {
  const bugun = new Date()
  bugun.setHours(0, 0, 0, 0)
  const t = new Date(d)
  t.setHours(0, 0, 0, 0)
  return bugun.getTime() === t.getTime()
}
